export const LOG_TYPES = {
  PRODUCT: 'product',
  CUSTOMER: 'customer',
  PACKAGE: 'package',
  ORDER: 'order',
  ALL: 'all'
}
export const LOG_ENDPOINT = route('api.tables.activity')
